import React from 'react'
import "./productList.css"
import Product from "../Product/Product"
import {products} from "../../data"

const ProductList = () => {
    return (
        <div className="pl">
            <div className="pl-text">
                <h1 className="pl-title">Create & inspire. It's Danish    </h1>
                <p className="pl-desc">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius libero dolorem repellendus a vitae beatae temporibus sed earum, iure voluptates, impedit ipsam, iste ex molestiae commodi dolor quasi esse quibusdam.
                </p>
            </div>
            <div className="pl-list ">
                {products.map((item)=>(
                    <Product key={item.id} img={item.img} link={item.link} />
                ))}
                
            </div>
        </div>
    )
}

export default ProductList;
